<template>
    <div>
      <section>
        <div class="section-inner">
          <div class="section-cont">
            <h2>제휴문의 담당자 관리</h2>
            <p class="site-path">
              <span>Home</span>&nbsp;&gt;&nbsp;
              <span>PRODUCTS</span>&nbsp;&gt;&nbsp;
              <span>제휴문의 담당자 관리</span>
            </p>
          </div>

          <app-footer/>
        </div>
      </section>
    </div>
</template>

<script>
import AppFooter from '../../AppFooter.vue';

export default {
  components: { AppFooter },
  name: 'PartnershipManagerShow',
}
</script>